import React from 'react';
import { useFeatureFlag } from 'new/hooks/useFeatureFlags';
import s from './SkeletonLogLine.module.scss';

type SkeletonLogLineProps = {
  lineNumberElementWidth: number;
  lineNumber?: number | string;
};

const SkeletonLogLineV1Component = ({ lineNumberElementWidth }: SkeletonLogLineProps) => {
  return (
    <div className={s.skeletonLogLine}>
      <span className={s.lineNumber} style={{ width: lineNumberElementWidth }} />
      <span className={s.timestamp} />
      <span className={s.severity} />
      <span className={s.resourceType} />
      <span className={s.content} />
    </div>
  );
};

const SkeletonLogLineV2Component = ({ lineNumberElementWidth }: SkeletonLogLineProps) => {
  return (
    <div className={s.skeletonLogLine}>
      <span className={s.lineNumber} style={{ width: lineNumberElementWidth }} />
      <span className={s.timestamp} />
      <span className={s.runId} />
      <span className={s.severity} />
      <span className={s.resourceType} />
      <span className={s.content} />
    </div>
  );
};

const SkeletonLogLineComponent = (props: SkeletonLogLineProps) => {
  const enableFlowInsightsV2 = useFeatureFlag('UI_ENABLE_FLOW_INSIGHTS_V2');
  const Component = enableFlowInsightsV2 ? SkeletonLogLineV2Component : SkeletonLogLineV1Component;
  return <Component {...props} />;
};

export const SkeletonLogLine = React.memo(SkeletonLogLineComponent);
SkeletonLogLine.displayName = 'SkeletonLogLine';
